export default {
  name: "header",
  api: {
    endpoints: {
      navigation: "/1.0/navigation",
    },
  },
};
